import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, ModalHeader } from "reactstrap";
import { AuthAPIService } from "src/api/Authentication/API_AuthService";
import { UserAPIService } from "src/api/Maintenance/API_UserService";
import { IChangeUserPassword } from "src/models/Maintenance/User.models";
import { removeAuthUser } from "src/services/Authentication/AuthenticationService";
import { logout } from "src/store/Authentication/authActions";
import { ChangePasswordForm } from "./ChangePasswordForm";
import { removeStoreXUser } from "src/services/Stores/FilteredStoreService";

interface IModalProps {
  tempPass: boolean;
}

const ChangePasswordPage = React.memo(({ tempPass }: IModalProps) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingLogout, setLoadingLogout] = useState<boolean>(false);

  useEffect(() => {
    return () => {
      setLoading(false);
      setLoadingLogout(false);
    };
  }, []);

  const initialValues: IChangeUserPassword = {
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
    tempPassword: tempPass,
  };

  const handleSubmit = useCallback(
    async (model: IChangeUserPassword) => {
      setLoading(true);
      try {
        const response = await UserAPIService.changePassword(model);
        if (response?.success) {
          logoutFn();
        }
      } catch (exception) {
      } finally {
        setLoading(false);
      }
    },
    [dispatch]
  );

  const logoutFn = (justLogout?: boolean) => {
    !justLogout ? setLoading(true) : setLoadingLogout(true);
    AuthAPIService.logout().finally(() => {
      !justLogout ? setLoading(false) : setLoadingLogout(false);
      sessionStorage.removeItem('purchaseRequestId');
      sessionStorage.removeItem('quotationId');
      sessionStorage.removeItem('invoicesListPage');
      sessionStorage.removeItem('itemCode');
      dispatch(logout());
      removeAuthUser();
      removeStoreXUser();
    });
  };

  const title = () => {
    return `Cambio de Contraseña`;
  };

  return (
    <Modal isOpen={true} size="xl" toggle={() => {}} autoFocus={false}>
      <ModalHeader>&nbsp;{title()}</ModalHeader>
      <ChangePasswordForm
        initialValues={initialValues}
        handleSubmit={handleSubmit}
        loading={loading}
        loadingLogout={loadingLogout}
        logout={logoutFn}
      />
    </Modal>
  );
});

export default ChangePasswordPage;
